import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { getAppI18nConfig, initI18n } from 'cfgi18n';
import i18next from 'i18next';
import { AppProps } from 'next/app';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';

import { Layout } from '../layouts/basic';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

function CustomApp({ Component, pageProps }: AppProps<{ locale: string }>) {
	const [ready, setReady] = useState<boolean>(false);

	useEffect(() => {
		const setup = async () => {
			const { supportedLocales } = await getAppI18nConfig('players');
			const i18n = await initI18n(pageProps.locale, supportedLocales);
			i18n.options.nsSeparator = false;
			setReady(true);
		};

		setup();
	}, []);

	if (!ready) return null;
	return (
		<>
			<Head>
				<title>Manchester City Squad Players</title>
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1.0"
				/>
				<meta
					name="description"
					content="Man City Men's, Women's, EDS, Academy squad players and Esports team members. Get the latest news, videos and social media for all the City roster. "
				/>
			</Head>

			<main className="app">
				<QueryClientProvider client={queryClient}>
					<I18nextProvider i18n={i18next}>
						<Layout>
							<Component {...pageProps} />
						</Layout>
					</I18nextProvider>
				</QueryClientProvider>
			</main>
		</>
	);
}

export default CustomApp;
